import React from 'react';
import { Row, Column } from '@upgrade/react-components';

import { Section } from '../common/styles';

import cityMontreal from '../../../static/img/careers/offices/Montreal.png';
import cityPhoenix from '../../../static/img/careers/offices/Phoenix.png';
import citySanFrancisco from '../../../static/img/careers/offices/SanFrancisco.png';
import cityAtlanta from '../../../static/img/careers/offices/Atlanta.png';
import cityOrangeCounty from '../../../static/img/careers/offices/OrangeCounty.png';
import allOffices from '../../../static/img/careers/offices/AllOffices.png';

import Fluid from '../Fluid';
import Office from './office';
import { Heading } from '../common/TypographyPublicSite';
import { AllOfficesImageContainer, OfficesContainer } from './styles';
import Image from '../common/Image';

const OurOffices = () => (
  <Section borderless id="about-us-page-offices" data-color="accentSecondary4">
    <Fluid padding="none">
      <Heading as="h2" size="sm" color="contentReverse" marginBottom="2xl" align="center">
        Our Offices
      </Heading>

      <OfficesContainer>
        <Row xsHorizontalAlign="center">
          <Column xs={12} sm={6} md={4}>
            <AllOfficesImageContainer>
              <Image src={allOffices} width={361} height={450} />
            </AllOfficesImageContainer>
          </Column>
          <Column xs={12} sm={6} md={4}>
            <Office
              imgSrc={citySanFrancisco}
              imgWidth={335}
              imgHeight={245}
              cityName="San Francisco"
              description="Headquarters"
              moreInfoText="See Open Positions"
              moreInfoLink="https://job-boards.greenhouse.io/upgrade?offices%5B%5D=4010105005"
              moreInfoLinkAriaLabel="See Open Positions"
            />
          </Column>
          <Column xs={12} sm={6} md={4}>
            <Office
              imgSrc={cityPhoenix}
              imgWidth={336}
              imgHeight={245}
              cityName="Phoenix"
              description="Service Center"
              moreInfoText="Learn more"
              moreInfoLink="/careers/phoenix"
              moreInfoLinkAriaLabel="Learn more about our Phoenix service center"
            />
          </Column>
          <Column xs={12} sm={6} md={4}>
            <Office
              imgSrc={cityMontreal}
              imgWidth={335}
              imgHeight={245}
              cityName="Montreal"
              description="Engineering Center"
              moreInfoText="See Open Positions"
              moreInfoLink="https://job-boards.greenhouse.io/upgrade?offices%5B%5D=4010109005 "
              moreInfoLinkAriaLabel="See Open Positions"
            />
          </Column>
          <Column xs={12} sm={6} md={4}>
            <Office
              imgSrc={cityAtlanta}
              imgWidth={336}
              imgHeight={245}
              cityName="Atlanta"
              description="Regional Office"
              moreInfoText="See Open Positions"
              moreInfoLink="https://job-boards.greenhouse.io/upgrade?offices%5B%5D=4010107005 "
              moreInfoLinkAriaLabel="See Open Positions"
            />
          </Column>
          <Column xs={12} sm={6} md={4}>
            <Office
              imgSrc={cityOrangeCounty}
              imgWidth={335}
              imgHeight={245}
              cityName="Orange County"
              description="Regional Office"
              moreInfoText="See Open Positions"
              moreInfoLink="https://job-boards.greenhouse.io/upgrade?offices%5B%5D=4017691005 "
              moreInfoLinkAriaLabel="See Open Positions"
            />
          </Column>
        </Row>
      </OfficesContainer>
    </Fluid>
  </Section>
);

export default OurOffices;
